module.exports = __webpack_public_path__ + "img/home-david.e890f540.jpg";